import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselDotDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        alignItems: "center"
    },
    selected: {
        ...webStyle({
            cursor: "default"
        })
    }
});

export const useStyles = ({
    isFocusVisible,
    orientation,
    isSelected,
    isHovered,
    borders,
    hitSize,
    colors
}: CarouselDotDynamicStyleType) => {
    const dotSize = borders.indicator * 2;

    const isVertical = orientation === "vertical";

    const styles = {
        dot: {
            backgroundColor: colors.content.icon.low,
            borderRadius: dotSize,
            height: dotSize,
            width: dotSize
        } as Mutable<ViewStyle>,
        surface: {
            borderRadius: hitSize,
            height: hitSize,
            width: hitSize
        } as Mutable<ViewStyle>,
        container: {
            height: hitSize,
            width: hitSize
        } as Mutable<ViewStyle>
    };

    if(isHovered && !isSelected) {
        styles.dot.backgroundColor = colors.content.icon.mid;
    }

    if(isSelected) {
        styles.dot.backgroundColor = colors.content.text.high;

        styles.dot[isVertical ? "height" : "width"] = dotSize * 2;
    }

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        isInset: true,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
